module.exports = __webpack_public_path__ + "img/XZ.2c22c46d.png";